__turbopack_context__.v({
  "chatWrapper": "index-module__kDXOvW__chatWrapper",
  "content": "index-module__kDXOvW__content",
  "splitterPanel": "index-module__kDXOvW__splitterPanel",
  "title": "index-module__kDXOvW__title",
  "withShadow": "index-module__kDXOvW__withShadow",
  "wrapper": "index-module__kDXOvW__wrapper",
});
